export default __webpack_public_path__ + "static/media/sequence-paused-circle.bff7802b.svg";